/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Finish_WinnerInputs */



/**
* | output |
* | --- |
* | "Winner" |
*
* @param {Meta_Finish_WinnerInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const meta_finish_winner = /** @type {((inputs?: Meta_Finish_WinnerInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Finish_WinnerInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sieger")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vainqueur")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("冠军")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("冠軍")
	if (locale === "ko") return /** @type {LocalizedString} */ ("우승")
	return /** @type {LocalizedString} */ ("Winner")
});